import { useState } from "react";

const GradeTab = ({
  groupedStudents,
  handleClickAllStudents,
  handleClickStudent,
  selectedParams,
}) => {
  const [expandedLevels, setExpandedLevels] = useState({});

  const handleToggle = (levelId) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [levelId]: !prev[levelId],
    }));
  };

  const styles = {
    classDetail: {
      color: "#737373",
    },
    classHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      border: "none",
      fontSize: "18px",
    },
    studentList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",
      maxHeight: "0",
      transition: "max-height 0.3s ease, opacity 0.3s ease",
      opacity: 0,
      fontSize: "16px",
    },
    studentListVisible: {
      maxHeight: "none",
      opacity: 1,
    },
    studentItem: {
      display: "flex",
      padding: "8px 10px",
      backgroundColor: "#fff",
      color: "#737373",
      border: "none",
      marginTop: "5px",
    },
  };

  return Object.entries(groupedStudents).map(([grade, { name, students }]) => (
    <li key={grade}>
      <div
        style={{
          backgroundColor: expandedLevels[grade] ? "#EBEBEB" : "#fff",
          color: expandedLevels[grade] ? "#000" : "#737373",
          ...styles.classHeader,
        }}
        onClick={() => handleToggle(grade)}
      >
        <span>{name}</span>
        <span style={styles.classDetail}>{students.length}명</span>
      </div>
      <ul
        style={{
          ...styles.studentList,
          ...(expandedLevels[grade] ? styles.studentListVisible : {}),
        }}
      >
        <li
          key={"group_" + grade}
          style={{
            ...styles.studentItem,
            color: selectedParams.studentGrade === grade ? "#000" : "#737373",
            fontWeight: "bold",
          }}
          onClick={() => handleClickAllStudents(grade)}
        >
          전체 학생
        </li>
      </ul>
      <ul
        style={{
          ...styles.studentList,
          ...(expandedLevels[grade] ? styles.studentListVisible : {}),
        }}
      >
        {students.map((student) => (
          <li
            key={student.id}
            style={{
              ...styles.studentItem,
              color:
                selectedParams.studentId === student.id ? "#000" : "#737373",
            }}
            onClick={() => handleClickStudent(student.id)}
          >
            {student.name}
          </li>
        ))}
      </ul>
    </li>
  ));
};

export default GradeTab;
